import { Injectable } from "@angular/core";
import { DwColumnFormatType, DwColumnRendererParams, DwDecoratorType, DwGridColumn, DwGridColumnDef, DwGridColumnRendererBase, 
         getDefaultColumnStyle, DwEventService } from "@devwareapps/devware-cap";
import { FleetMetaDataItemNames, AuctionEntity, CodeValueFleetAuctionStatus, FleetAuctionGridQueryQueryEntity } from "../meta-data/fleet-meta-data.service";
import * as moment_ from 'moment';
const moment = moment_;

@DwGridColumn({
    keyName: 'fleet-currentbid-column',
    display: 'Fleet - Current Bid',
    decoratorType: DwDecoratorType.service,
    isGlobal: false,
    parentItemName:  [ FleetMetaDataItemNames.Auction ],
    allowAttr: false,
    requireAttr: false,
    allowAction: true,
    order: 1,
    columnStyleFunc: getDefaultColumnStyle,
})
@Injectable()
export class FleetAuctionCurrentBidColumnService implements DwGridColumnRendererBase {
   
    constructor(
        private dwEventService: DwEventService,
    ) { }
  
    renderColumn(columnConfig: DwGridColumnDef<any>): (params: DwColumnRendererParams) => any {
        return (params) => {
            const data: FleetAuctionGridQueryQueryEntity = params.data;
            if (!data) return "";
            return  data.StatusCv == CodeValueFleetAuctionStatus.NotStartedNew
                        ? `<span class="dw-red">Not Started</span>` :
                    data.StatusCv == CodeValueFleetAuctionStatus.ActiveOpen 
                        ? (data.RoAuctionCurrentBid > 0 ? `<span class="dw-green">$${(data.RoAuctionCurrentBid).toFixed(2)}</span>` 
                                                        : `<span style="color:gray">$${(data.StartingPrice ?? 0).toFixed(2)}</span>`):
                    "";
        }
    }
}